<template>
  <footer class="bg-indigo-950 text-white/80 mt-16">
    <div class="max-w-[1200px] mx-auto px-6 pt-12 pb-8 flex flex-col items-center text-center gap-6">
      
      <!-- Brand -->
      <div class="flex flex-col items-center">
        <div class="flex items-center gap-2">
          <span class="text-2xl text-amber-500">✦</span>
          <span class="font-bold text-xl tracking-tight text-white">АртМандала</span>
        </div>
        <p class="text-[0.9rem] text-white/50 mt-2">Исцеляющее искусство и самопознание через мандалы</p>
      </div>

      <!-- Links -->
      <div class="flex flex-col md:flex-row gap-3 md:gap-6 justify-center flex-wrap">
        <router-link to="/" class="text-white/60 text-[0.9rem] hover:text-white transition-colors">Главная</router-link>
        <a href="/blog/" class="text-white/60 text-[0.9rem] hover:text-white transition-colors">Блог</a>
        <router-link to="/nabory/" class="text-white/60 text-[0.9rem] hover:text-white transition-colors">Наборы</router-link>
        <router-link to="/pndpolicy" class="text-white/60 text-[0.9rem] hover:text-white transition-colors">Политика конфиденциальности</router-link>
        <router-link to="/oferta" class="text-white/60 text-[0.9rem] hover:text-white transition-colors">Публичная Оферта</router-link>
      </div>

      <!-- Copyright -->
      <div class="text-[0.8rem] text-white/35 pt-4 border-t border-white/10 w-full mt-2">
        &copy; 2023-{{ new Date().getFullYear() }} АртМандала. Все права защищены.
      </div>

    </div>
  </footer>
</template>

<script setup>
// Minimal logic needed for footer
</script>